import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deliverOrder, detailsOrder, payOrder } from "../actions/orderActions";
import MessageBox from "../components/messageBox";
import LoadingBox from "../components/loadingBox";
import NavBar from "../components/navbar";
import Footer from "../components/footer";
import CheckoutSteps from "../components/checkoutSteps";
import { Link } from "react-router-dom";
import axios from "axios";
import { PayPalButton } from "react-paypal-button-v2";
import { ORDER_DELIVER_RESET, ORDER_PAY_RESET } from "../reducers/actionTypes";

function OrderPage(props) {
  const orderId = props.match.params.id;
  //paypal SDK
  const [sdkReady, setSdkReady] = useState(false);
  const orderDetails = useSelector((state) => state.orderDetails);
  const { order, loading, error } = orderDetails;
  const userSignin = useSelector((state) => state.userSignin);
  const { userInfo } = userSignin;
  //check payment result
  const orderPay = useSelector((state) => state.orderPay);
  const {
    loading: loadingPay,
    error: errorPay,
    success: successPay,
  } = orderPay;

  const orderDeliver = useSelector((state) => state.orderDeliver);
  const {
    loading: loadingDeliver,
    error: errorDeliver,
    success: successDeliver,
  } = orderDeliver;

  const dispatch = useDispatch();

  useEffect(() => {
    const addPayPalScript = async () => {
      const { data } = await axios.get("/api/config/paypal");
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = `https://www.paypal.com/sdk/js?client-id=${data}`;
      script.async = true;
      script.onload = () => {
        setSdkReady(true);
      };
      document.body.appendChild(script);
    };
    if (
      !order ||
      successPay ||
      successDeliver ||
      (order && order._id !== orderId)
    ) {
      dispatch({ type: ORDER_PAY_RESET });
      dispatch({ type: ORDER_DELIVER_RESET });
      dispatch(detailsOrder(orderId));
    } else {
      if (!order.isPaid) {
        if (!window.paypal) {
          addPayPalScript();
        } else {
          setSdkReady(true);
        }
      }
    }
  }, [dispatch, order, orderId, sdkReady, successPay, successDeliver]);

  const successPaymentHandler = (paymentResult) => {
    // dispatch pay order
    dispatch(payOrder(order, paymentResult));
  };

  const deliverHandler = () => {
    dispatch(deliverOrder(order._id));
  };
  // no paypal
  // useEffect(() => {
  //   dispatch(detailsOrder(orderId));
  // }, [dispatch, orderId]);

  return loading ? (
    <LoadingBox></LoadingBox>
  ) : error ? (
    <MessageBox variant="danger">{error}</MessageBox>
  ) : (
    <div>
      <NavBar />
      <div className="mt-4 ">
        <div className="col-lg-8 mx-auto">
          <CheckoutSteps step1 step2 step3 step4 />
        </div>
        <div className="container ">
          <div className="row  d-flex">
            <div className="col col-lg-8 mb-5">
              <div className=" pt-5 mb-1">
                <div className="shippinginfo mb-3">
                  <div className="shipping_info">Shipping </div>
                  <div>
                    <strong>Name:</strong> {order.shippingAddress.fullName}
                    <br />
                    <strong>Address: </strong> {order.shippingAddress.address},
                    {order.shippingAddress.city},{" "}
                    {order.shippingAddress.zipcode},
                    {order.shippingAddress.country}.
                  </div>
                  {order.isDelivered ? (
                    <MessageBox variant="success">
                      Delivered at {order.deliveredAt}
                    </MessageBox>
                  ) : (
                    <MessageBox variant="danger">Not Delivered</MessageBox>
                  )}
                </div>
                <div className="paymentinfo mb-5">
                  <div className="payment_info">Payment </div>
                  <div>Method: {order.paymentMethod}</div>
                  {order.isPaid ? (
                    <MessageBox variant="success">
                      Paid at {order.paidAt}
                    </MessageBox>
                  ) : (
                    <MessageBox variant="danger">Not Paid</MessageBox>
                  )}
                </div>
              </div>
              <div className=" orderitem">
                <div className=" d-flex  col-lg-8 shopping align-items-end">
                  <div className="shopping_cart flex-fill  col-lg-6 mb-3">
                    Order Items
                  </div>
                </div>
                <div className="col col-lg-8 mb-3 listing">
                  <ul className="list-unstyled">
                    {order.orderItems.map((item) => (
                      <div key={item.name}>
                        <li className="d-flex  mb-5">
                          <div className="order_img col col-lg-3">
                            <img src={item.image} width="100" alt="product" />
                          </div>
                          <div className="order_info col col-md-6 col-lg-6 ">
                            <div className="d-flex justify-content-end">
                              <ul className="list-unstyled ">
                                <li className="order_name ">
                                  <Link
                                    to={`/products/${item.product}`}
                                    className="text-decoration-none"
                                  >
                                    <strong>{item.name}</strong>
                                  </Link>
                                </li>
                                <li className="d-flex ">
                                  {item.qty} x ${item.price} = $
                                  {item.qty * item.price}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                      </div>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col col-lg-4 mt-5 ">
              <div className="card  order_action">
                <div className="card-body">
                  <div className="mt-1">
                    <strong>Order Summary</strong>
                  </div>
                  <div className="order_summary mt-2 mb-3">
                    <div className="row justify-content-between">
                      <div className="col-4">Items</div>
                      <div className="col-4 text-end">
                        ${order.itemsPrice.toFixed(2)}
                      </div>
                    </div>
                    <div className="row justify-content-between">
                      <div className="col-4">Shipping</div>
                      <div className="col-4 text-end">
                        ${order.shippingPrice.toFixed(2)}
                      </div>
                    </div>
                    <div className="row justify-content-between">
                      <div className="col-4">Tax</div>
                      <div className="col-4 text-end">
                        ${order.taxPrice.toFixed(2)}
                      </div>
                    </div>
                    <div className="row justify-content-between mb-3">
                      <div className="col-4">
                        <strong>Total</strong>
                      </div>
                      <div className="col-4 text-end">
                        <strong>${order.totalPrice.toFixed(2)}</strong>
                      </div>
                    </div>
                    {userInfo.isAdmin && order.isPaid && !order.isDelivered && (
                      <div className="deliver mt-1">
                        {loadingDeliver && <LoadingBox></LoadingBox>}
                        {errorDeliver && (
                          <MessageBox variant="danger">
                            {errorDeliver}
                          </MessageBox>
                        )}
                        <button
                          type="button"
                          className="btn btn-warning"
                          onClick={deliverHandler}
                        >
                          Deliver Order
                        </button>
                      </div>
                    )}

                    {!order.isPaid && (
                      <div>
                        {!sdkReady ? (
                          <LoadingBox></LoadingBox>
                        ) : (
                          <>
                            {errorPay && (
                              <MessageBox variant="danger">
                                {errorPay}
                              </MessageBox>
                            )}
                            {loadingPay && <LoadingBox></LoadingBox>}

                            <PayPalButton
                              amount={order.totalPrice}
                              onSuccess={successPaymentHandler}
                            ></PayPalButton>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default OrderPage;
